{
  "source": "api/src/activity-pack/packs",
  "packs": [
    {
      "slug": "barbearia",
      "label": "Barbearia",
      "categorySlug": "beleza",
      "enrollmentTerm": "assinatura",
      "services": [
        {
          "name": "Assinatura Mensal de Corte Simples",
          "price": 250,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 4,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Assinatura Mensal Corte + Barba",
          "price": 420,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 4,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Corte masculino",
          "price": 45,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Corte + barba",
          "price": 75,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Barba",
          "price": 35,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Corte infantil",
          "price": 40,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Pezinho",
          "price": 20,
          "priceDisplayMode": "show",
          "durationMinutes": 15,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Sobrancelha na navalha",
          "price": 20,
          "priceDisplayMode": "show",
          "durationMinutes": 15,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 120,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": []
    },
    {
      "slug": "cabeleireiro",
      "label": "Cabeleireira",
      "categorySlug": "beleza",
      "enrollmentTerm": "assinatura",
      "services": [
        {
          "name": "Assinatura Mensal de Escova",
          "price": 200,
          "priceDisplayMode": "show",
          "durationMinutes": 45,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 4,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Corte feminino",
          "price": 80,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Escova",
          "price": 55,
          "priceDisplayMode": "show",
          "durationMinutes": 45,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Hidratação",
          "price": 90,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Coloração",
          "price": 180,
          "priceDisplayMode": "from",
          "durationMinutes": 120,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Luzes / mechas",
          "price": 300,
          "priceDisplayMode": "from",
          "durationMinutes": 180,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Progressiva",
          "price": 250,
          "priceDisplayMode": "from",
          "durationMinutes": 150,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Penteado",
          "price": 150,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 120,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": []
    },
    {
      "slug": "manicure",
      "label": "Manicure e pedicure",
      "categorySlug": "beleza",
      "enrollmentTerm": "assinatura",
      "services": [
        {
          "name": "Assinatura de Manutenção Mensal",
          "price": 100,
          "priceDisplayMode": "show",
          "durationMinutes": 120,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 2,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Mão simples",
          "price": 35,
          "priceDisplayMode": "show",
          "durationMinutes": 45,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Pé e mão",
          "price": 60,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Esmaltação em gel",
          "price": 75,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Alongamento em gel",
          "price": 180,
          "priceDisplayMode": "from",
          "durationMinutes": 180,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Manutenção de alongamento",
          "price": 100,
          "priceDisplayMode": "show",
          "durationMinutes": 120,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Spa dos pés",
          "price": 70,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 120,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Assinatura mensal de manutenção de unhas",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "estetica",
      "label": "Estética",
      "categorySlug": "beleza",
      "enrollmentTerm": "plano",
      "services": [
        {
          "name": "Assinatura Mensal de Skincare",
          "price": 130,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 1,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Limpeza de pele profunda",
          "price": 150,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Design de sobrancelha",
          "price": 40,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Depilação com cera",
          "price": 45,
          "priceDisplayMode": "from",
          "durationMinutes": 45,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Massagem modeladora",
          "price": 120,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Drenagem linfática",
          "price": 130,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Peeling de diamante",
          "price": 180,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 120,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Pacote de 10 sessões",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "personal-trainer",
      "label": "Personal trainer",
      "categorySlug": "fitness",
      "enrollmentTerm": "matrícula",
      "services": [
        {
          "name": "Plano 2x por semana",
          "price": 520,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 2,
          "quotaPeriod": "WEEK"
        },
        {
          "name": "Plano 3x por semana",
          "price": 700,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 3,
          "quotaPeriod": "WEEK"
        },
        {
          "name": "Avaliação física",
          "price": 130,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Aula avulsa",
          "price": 100,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Treino online",
          "price": 200,
          "priceDisplayMode": "from",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 720,
      "reminderEnabled": true,
      "reminderLeadMinutes": 720,
      "contractTemplates": [
        {
          "name": "Mensalidade 3x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Mensalidade 2x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "professor-particular",
      "label": "Professor particular",
      "categorySlug": "aulas",
      "enrollmentTerm": "matrícula",
      "services": [
        {
          "name": "Plano 1x por semana",
          "price": 340,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 1,
          "quotaPeriod": "WEEK"
        },
        {
          "name": "Plano 2x por semana",
          "price": 620,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 2,
          "quotaPeriod": "WEEK"
        },
        {
          "name": "Aula diagnóstica",
          "price": 60,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Aula avulsa",
          "price": 90,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Reforço em grupo",
          "price": 50,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 720,
      "reminderEnabled": true,
      "reminderLeadMinutes": 720,
      "contractTemplates": [
        {
          "name": "Mensalidade 2x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 10,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Mensalidade 1x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 10,
          "reminderType": "ON_DUE_DATE"
        }
      ]
    },
    {
      "slug": "pilates-estudio",
      "label": "Estúdio de pilates",
      "categorySlug": "fitness",
      "enrollmentTerm": "matrícula",
      "services": [
        {
          "name": "Plano 2x por semana",
          "price": 390,
          "priceDisplayMode": "show",
          "durationMinutes": 55,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 2,
          "quotaPeriod": "WEEK"
        },
        {
          "name": "Plano 3x por semana",
          "price": 520,
          "priceDisplayMode": "show",
          "durationMinutes": 55,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 3,
          "quotaPeriod": "WEEK"
        },
        {
          "name": "Pilates individual",
          "price": 160,
          "priceDisplayMode": "show",
          "durationMinutes": 55,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Aula experimental",
          "price": 50,
          "priceDisplayMode": "show",
          "durationMinutes": 55,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Avaliação postural",
          "price": 130,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Aula avulsa",
          "price": 80,
          "priceDisplayMode": "show",
          "durationMinutes": 55,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 240,
      "reminderEnabled": true,
      "reminderLeadMinutes": 720,
      "contractTemplates": [
        {
          "name": "Mensalidade 2x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Mensalidade 3x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "FIVE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "diarista",
      "label": "Diarista",
      "categorySlug": "limpeza",
      "enrollmentTerm": "contrato",
      "services": [
        {
          "name": "Diária de limpeza",
          "price": 180,
          "priceDisplayMode": "from",
          "durationMinutes": 360,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Meia diária",
          "price": 130,
          "priceDisplayMode": "from",
          "durationMinutes": 240,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Passar roupa",
          "price": 110,
          "priceDisplayMode": "from",
          "durationMinutes": 240,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Faxina pesada",
          "price": null,
          "priceDisplayMode": "hidden",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 1440,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Diarista semanal",
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "chargeDay": null,
          "reminderType": "ON_DUE_DATE"
        },
        {
          "name": "Faxina quinzenal",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Faxina mensal",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 10,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "jardinagem",
      "label": "Jardinagem",
      "categorySlug": "casa",
      "enrollmentTerm": "contrato",
      "services": [
        {
          "name": "Corte de grama",
          "price": 120,
          "priceDisplayMode": "from",
          "durationMinutes": 120,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Manutenção de jardim",
          "price": 180,
          "priceDisplayMode": "from",
          "durationMinutes": 180,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Limpeza de terreno",
          "price": 300,
          "priceDisplayMode": "from",
          "durationMinutes": 240,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Poda de árvore",
          "price": null,
          "priceDisplayMode": "hidden",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Projeto de paisagismo",
          "price": null,
          "priceDisplayMode": "hidden",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 1440,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Manutenção mensal de jardim",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 10,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Corte de grama quinzenal",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "ON_DUE_DATE"
        }
      ]
    },
    {
      "slug": "reforma-pintura",
      "label": "Reforma e pintura",
      "categorySlug": "casa",
      "enrollmentTerm": "contrato",
      "services": [
        {
          "name": "Assinatura de Manutenção Mensal",
          "price": 350,
          "priceDisplayMode": "show",
          "durationMinutes": 240,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 1,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Visita técnica de orçamento",
          "price": 0,
          "priceDisplayMode": "hidden",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Pequenos reparos",
          "price": 200,
          "priceDisplayMode": "from",
          "durationMinutes": 240,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Pintura de ambiente",
          "price": null,
          "priceDisplayMode": "hidden",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Reforma de banheiro",
          "price": null,
          "priceDisplayMode": "hidden",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 2880,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Obra fechada",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Pintura por ambiente",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "ON_DUE_DATE"
        }
      ]
    },
    {
      "slug": "psicologo",
      "label": "Psicólogo",
      "categorySlug": "saude",
      "enrollmentTerm": "acompanhamento",
      "services": [
        {
          "name": "Sessão de psicoterapia individual",
          "price": 180,
          "priceDisplayMode": "show",
          "durationMinutes": 50,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Primeira consulta",
          "price": 180,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Sessão de terapia de casal",
          "price": 260,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Avaliação psicológica com laudo",
          "price": 900,
          "priceDisplayMode": "from",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 1440,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Mensalidade de terapia semanal",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Pacote de 4 sessões",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "ON_DUE_DATE"
        }
      ]
    },
    {
      "slug": "fisioterapeuta",
      "label": "Fisioterapeuta",
      "categorySlug": "saude",
      "enrollmentTerm": "tratamento",
      "services": [
        {
          "name": "Sessão de fisioterapia ortopédica",
          "price": 120,
          "priceDisplayMode": "show",
          "durationMinutes": 50,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Avaliação fisioterapêutica",
          "price": 150,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Sessão de RPG",
          "price": 160,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Pilates clínico em grupo",
          "price": 90,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Atendimento domiciliar",
          "price": 200,
          "priceDisplayMode": "from",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "WEEKLY",
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 1440,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Pacote de 10 sessões",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Mensalidade de pilates clínico 2x por semana",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 10,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "banho-e-tosa",
      "label": "Banho e tosa",
      "categorySlug": "pets",
      "enrollmentTerm": "plano",
      "services": [
        {
          "name": "Assinatura Mensal — 4 banhos (porte pequeno)",
          "price": 220,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 4,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Banho — porte pequeno",
          "price": 60,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Banho — porte médio",
          "price": 80,
          "priceDisplayMode": "show",
          "durationMinutes": 75,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Banho — porte grande",
          "price": 110,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Banho e tosa higiênica — porte pequeno",
          "price": 90,
          "priceDisplayMode": "show",
          "durationMinutes": 90,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Banho e tosa completa — porte médio",
          "price": 140,
          "priceDisplayMode": "show",
          "durationMinutes": 120,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Tosa na tesoura",
          "price": 180,
          "priceDisplayMode": "from",
          "durationMinutes": 150,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Hidratação",
          "price": 45,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 1440,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Plano mensal — 4 banhos",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Pacote de 5 banhos",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "ON_DUE_DATE"
        }
      ]
    },
    {
      "slug": "transporte-escolar",
      "label": "Transporte escolar",
      "categorySlug": "transporte",
      "enrollmentTerm": "mensalidade",
      "services": [
        {
          "name": "Mensalidade — ida e volta",
          "price": 320,
          "priceDisplayMode": "show",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Mensalidade — só ida",
          "price": 200,
          "priceDisplayMode": "show",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Mensalidade — só volta",
          "price": 200,
          "priceDisplayMode": "show",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Taxa de matrícula",
          "price": 120,
          "priceDisplayMode": "show",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Transporte para passeio ou excursão",
          "price": 250,
          "priceDisplayMode": "from",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 1440,
      "reminderEnabled": false,
      "reminderLeadMinutes": 0,
      "contractTemplates": [
        {
          "name": "Mensalidade escolar — ida e volta",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Mensalidade escolar — meio período",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        }
      ]
    },
    {
      "slug": "contador",
      "label": "Contador",
      "categorySlug": "consultoria",
      "enrollmentTerm": "contrato",
      "services": [
        {
          "name": "Honorário mensal — MEI",
          "price": 99,
          "priceDisplayMode": "show",
          "durationMinutes": 30,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 1,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Honorário mensal — Simples Nacional",
          "price": 450,
          "priceDisplayMode": "from",
          "durationMinutes": 60,
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "isSubscription": true,
          "quota": 1,
          "quotaPeriod": "MONTH"
        },
        {
          "name": "Folha de pagamento — por funcionário",
          "price": 80,
          "priceDisplayMode": "show",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Abertura de empresa (CNPJ)",
          "price": 600,
          "priceDisplayMode": "from",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Declaração de imposto de renda (pessoa física)",
          "price": 250,
          "priceDisplayMode": "from",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Alteração contratual ou baixa de empresa",
          "price": 450,
          "priceDisplayMode": "from",
          "durationMinutes": null,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        },
        {
          "name": "Consultoria contábil avulsa",
          "price": 200,
          "priceDisplayMode": "show",
          "durationMinutes": 60,
          "billingModel": "ONE_TIME",
          "interval": null,
          "isSubscription": false,
          "quota": null,
          "quotaPeriod": null
        }
      ],
      "minCancelLeadMinutes": 720,
      "reminderEnabled": true,
      "reminderLeadMinutes": 1440,
      "contractTemplates": [
        {
          "name": "Honorário mensal — MEI",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 25,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Honorário mensal — Simples Nacional",
          "billingModel": "RECURRING",
          "interval": "MONTHLY",
          "chargeDay": 5,
          "reminderType": "THREE_DAYS_BEFORE_AND_ON_DUE"
        },
        {
          "name": "Serviço avulso — abertura, alteração ou declaração",
          "billingModel": "ONE_TIME",
          "interval": null,
          "chargeDay": null,
          "reminderType": "ON_DUE_DATE"
        }
      ]
    }
  ]
}
